import { render } from "./AppVersionList.vue?vue&type=template&id=629054e2"
import script from "./AppVersionList.vue?vue&type=script&lang=js"
export * from "./AppVersionList.vue?vue&type=script&lang=js"

import "./AppVersionList.vue?vue&type=style&index=0&id=629054e2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__